import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { IAuthResponse, IPermission } from "../../interfaces/auth";
import Cookies from "js-cookie";
import { AuthServices } from "../../services/auth";
import { Flex, Spin } from "antd";
import { COOKIE_AUTH_TOKEN } from "../../constants/common";
import { useMessageApi } from "../../context/MessageContext";

const OauthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const messageApi = useMessageApi();

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");

    if (!code) return;

    const handleLogin = async () => {
      try {
        const body = {
          code: code,
          redirectUrl: `${window.location.origin}/oauth2/callback`,
        };
        const res = (await AuthServices.logIn(body)) as unknown as {
          success: boolean;
          data: IAuthResponse;
        };

        if (res.success) {
          const { accessToken, userInfo } = res.data;
          Cookies.set(COOKIE_AUTH_TOKEN, accessToken, {
            secure: true,
            sameSite: "Strict",
            expires: 1,
          });
          setUser(userInfo);
          messageApi.success("Login successfully!");
          navigate(`/${getLink(userInfo?.roles?.[0]?.permissions || [])}`);
        } else {
          messageApi.error("Access Denied");
          navigate("/login");
        }
      } catch (error: any) {
        const errorMsg = Array.isArray(error?.message)
          ? error.message.join(" ")
          : error?.message || "Access Denied";
        messageApi.error(errorMsg);
        navigate("/login");
      }
    };

    handleLogin();
  }, [messageApi, navigate, setUser]);

  const getLink = (permission: IPermission[])=> {
    const moduleName = permission.map((p)=> p.moduleName);
    if (moduleName.includes("DASHBOARD")) {
      return "dashboard"
    }
    if (moduleName.includes("WORKFLOW")) {
      return "ap-workflow"
    }
    if (moduleName.includes("SUPPLIER")) {
      return "supplier"
    }
    if (moduleName.includes("FINANCIAL_REPORT")) {
      return "financial-reporting"
    }
    if (moduleName.includes("BOOKING_SUPPLIER_COST")) {
      return "booking-supplier-cost"
    }
    if (moduleName.includes("INVOICE")) {
      return "invoice"
    }
    if (moduleName.includes("SYSTEM_DEFAULT")) {
      return "system-default"
    }
    if (moduleName.includes("MASTER_DATA")) {
      return "master-data"
    }

    return "permission"
  }

  return (
    <Flex gap="middle" vertical style={{ padding: "2rem" }}>
      <Spin size="large" />
    </Flex>
  );
};

export default OauthCallback;
